import { visuallyHiddenStyles } from "@newsela/angelou";
import PropTypes from "prop-types";

import NestedIcon from "@/icons/NestedIcon";
import AnnotationCommentActions from "../Actions/AnnotationCommentActions";
import AnnotationCommentDeleteConfirmation from "../AnnotationCommentDeleteConfirmation";
import {
  rootCss,
  iconCss,
  nameHeadingCss,
  textCss,
  nameAndActionsCss,
} from "./AnnotationComment.style";
const propTypes = {
  commentActionProps: PropTypes.object,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  shouldShowDeleteConfirmation: PropTypes.bool,
  text: PropTypes.string,
};

const AnnotationComment = ({
  commentActionProps = null,
  firstName,
  lastName,
  shouldShowDeleteConfirmation,
  text,
}) => {
  const isCommentEditMode = commentActionProps?.isCommentEditMode;
  return (
    <div css={rootCss}>
      {commentActionProps && shouldShowDeleteConfirmation && (
        <AnnotationCommentDeleteConfirmation
          commentActionProps={commentActionProps}
        />
      )}
      <div css={nameAndActionsCss}>
        <NestedIcon css={iconCss} />
        <h4 css={nameHeadingCss}>
          <span css={visuallyHiddenStyles}>Reply from: </span>
          {`${firstName.charAt(0)}. ${lastName}`}
        </h4>
        {commentActionProps && (
          <AnnotationCommentActions
            shouldShowDeleteConfirmation={shouldShowDeleteConfirmation}
            {...commentActionProps}
          />
        )}
      </div>
      {!isCommentEditMode && <div css={textCss}>{text}</div>}
    </div>
  );
};

AnnotationComment.propTypes = propTypes;
export default AnnotationComment;
